(function () {
  'use strict';

  class UsuariosCtrl {
    constructor(UsuariosServiceV2, Uos, Flash, $uibModal, UoArvoreNivel, Keys, ServiceVfiltro, FactoryVfiltro, PerfilAdminVeltec,
      PerfilIntegracao, AlertMessage, VtabelaFactory, IdiomasEnum, MeasurementSystemEnum, RolesEnum, $translate, Authenticator, Restangular,
      FeaturehubJsSdk, FeatureHubConfigKeys) {
      this.usuariosServiceV2 = UsuariosServiceV2;
      this.uoService = Uos;
      this.restangular = Restangular;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.rolesEnum = RolesEnum;
      this.uoArvoreNivel = UoArvoreNivel;
      this.flash = Flash;
      this.modalService = $uibModal;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.vtabelaFactory = VtabelaFactory;
      this.perfilIntegracao = PerfilIntegracao;
      this.alertMessage = AlertMessage;
      this.roleCadastrar = false;
      this.uoArvore = [];
      this.PERFIL_VDRIVERS = 4;
      this.FIELDS_USUARIO = [
        'id',
        'login',
        'uoId',
        'perfil.id',
        'perfil.nome',
        'uo.nome',
        'ultimoAcesso',
        'cargo',
        'nome',
        'lastName',
        'pais',
        'pais.code',
        'pais.nome',
        'telefone',
        'paisTelefone.ddi',
        'paisTelefone.nome',
        'paisTelefone.code',
        'ddd',
        'pais',
        'ddi',
        'idioma',
        'measurementSystem',
        'isResponsavelPassiveis',
        'acessoTrocaUo',
        'email'
      ];
      this.whiteList = [
        'veltec.com.br',
        'trimble.com',
        'grparceria.com.br',
        'platformscience.com'
      ];
      this.SUPPORT = 1800;
      this.translate = $translate;

      this.authenticator = Authenticator;
      this.authenticator.getUser().then(user => {
        this.dateTimeFormat = user.measurementUnits.dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy HH:mm:ss' : 'MM/dd/yyyy HH:mm:ss';
      });

      this.vtabela = null;
      this.isNaOu = false;
      ServiceVfiltro.init(FactoryVfiltro.get([
        {
          key: Keys.uo.name
        }
      ]))
        .then(filtro => {
          this.uoId = filtro.find(x => x.key === Keys.uo.name).value.id;
          this.user = ServiceVfiltro.factoryVfiltro.user;
          this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('USUARIO_EDITAR');
          this.loadNaFeature(this.uoId).then(() => {
            this.vtabela = this.vtabelaFactory.get(this.initVtabela(), ServiceVfiltro.factoryVfiltro.user, 'usuarios', this.getTableVersion());
            this.carregarArvoreUoUsuario();
            this.carregarUsuarios();
          });
        });
    }

    loadNaFeature(uoId) {
      return this.restangular.one(`configuracao/configuracoes/${uoId}/feature-ou`).get()
        .then(featureOu => this.isNaOu = featureOu.plain().vi20ProductName === true)
        .catch(() => this.isNaOu = false);
    }

    getTableVersion() {
      return this.isNaOu ? 'v2-na' : 'v2';
    }

    initVtabela() {
      let objVtabela = {
        appScopeProvider: this,
        enableRowSelection: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        exportsCsv: false,
        enableSelectAll: false,
        showColumnFooter: false,
        isRowSelectable: () => {
          return false;
        },
        columnDefs: [
            {
              name: 'uo',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.ou'),
              type: 'string',
              pinnedLeft: true,
              enableHiding: false,
              filterCellFiltered: true
            },
            {
              name: 'email',
              displayName: 'E-mail',
              pinnedLeft: true,
              type: 'string',
              enableHiding: false,
              filterCellFiltered: true
            },
            {
              name: 'nome',
              displayName: this.translate.instant(this.isNaOu ?
                'core-permissoes.organizacao.usuarios.firstName' :
                'core-permissoes.organizacao.usuarios.name'),
              pinnedLeft: true,
              type: 'string',
              enableHiding: false,
              filterCellFiltered: true
            },
            {
              name: 'perfil',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.role'),
              type: 'string',
              enableHiding: false,
              filterCellFiltered: true
            },
            {
              name: 'pais',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.country'),
              type: 'string',
              filterCellFiltered: true
            },
            {
              name: 'languageLabel',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.language'),
              type: 'string',
              filterCellFiltered: true
            },
            {
              name: 'measurementSystem',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.popup.measurementSystem'),
              type: 'string',
              filterCellFiltered: true
            },
            {
              name: 'telefone',
              type: 'string',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.phone'),
              filterCellFiltered: true
            },
            {
              name: 'cargo',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.position'),
              type: 'string',
              filterCellFiltered: true
            },
            {
              name: 'manutencao',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.maintenance'),
              type: 'string',
              filterCellFiltered: true
            },
            {
              name: 'ultimoLogin',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.lastLogin'),
              type: 'date',
              cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
              cellClass: 'text-center',
              filterCellFiltered: true
            },
            {
              name: 'acoes',
              displayName: this.translate.instant('core-permissoes.organizacao.usuarios.actions'),
              pinnedRight: true,
              enableSorting: false,
              enableHiding: false,
              enableFiltering: false,
              enableColumnResizing: false,
              visible: this.roleCadastrar,
              width: 100,
              cellTemplate: `
                  <div class='ui-grid-cell-contents text-center'>
                    <button class="btn btn-info btn-xs" ng-click="grid.appScope.editarUsuario(row.entity.usuario)" ng-if="grid.appScope.allowEdit(row.entity.usuario)">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-danger btn-xs" ng-click="grid.appScope.excluirUsuario(row.entity.usuario)" ng-if="grid.appScope.allowEdit(row.entity.usuario)">
                      <i class="fa fa-remove"></i>
                    </button>
                  </div>
                `
            }
        ]
      };
      if (this.isNaOu) {
        const indexNome = objVtabela.columnDefs.findIndex(column => column.name === 'nome');
        objVtabela.columnDefs.splice(indexNome + 1, 0, {
          name: 'lastName',
          displayName: this.translate.instant('core-permissoes.organizacao.usuarios.lastName'),
          pinnedLeft: true,
          type: 'string',
          enableHiding: false,
          filterCellFiltered: true
        });
      }
      if (!this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.MEASUREMENT_SYSTEM)) {
        objVtabela.columnDefs = objVtabela.columnDefs.filter(column => column.name !== 'measurementSystem');
      }
      return objVtabela;
    }

    getItemVtabela(item) {
      return {
        usuario: item,
        uo: item.uo.nome,
        email: item.login,
        nome: item.nome,
        lastName: item.lastName,
        perfil: this.getPerfil(item),
        pais: item.pais ? item.pais.nome : null,
        telefone: this.getTelefone(item),
        cargo: item.cargo,
        languageLabel: item.languageLabel,
        measurementSystem: this.getMeasurementSystem(item),
        manutencao: this.getIsReponsavelPassiveis(item.isResponsavelPassiveis),
        ultimoLogin: item.ultimoAcesso
      };
    }

    getPerfil(item) {
      if (item.perfil) {
        return this.rolesEnum.getDescricaoByDescricaoDB(item.perfil.nome) ? this.translate.instant(
          this.rolesEnum.getDescricaoByDescricaoDB(item.perfil.nome)) : item.perfil.nome;
      }
      return null;
    }

    getMeasurementSystem(user) {
      const key = user.measurementSystem || this.measurementSystemEnum.getDefaultKeyForLanguage(user.idioma);
      return this.translate.instant(this.measurementSystemEnum.getSystemByKey(key).label);
    }

    getTelefone(usuario) {
      if (usuario.telefone) {
        const ddi = usuario.paisTelefone ? '+' + usuario.paisTelefone.ddi : '';
        return `${ddi}${usuario.ddd}${usuario.telefone}`;
      }
      return null;
    }

    getIsReponsavelPassiveis(isResponsavelPassiveis) {
      if (angular.isDefined(isResponsavelPassiveis)) {
        return this.translate.instant(isResponsavelPassiveis ? 'core-permissoes.organizacao.usuarios.yes' : 'core-permissoes.organizacao.usuarios.no');
      }
      return isResponsavelPassiveis;
    }

    setInfoTable(data) {
      this.vtabela.setData(data.map(i => this.getItemVtabela(i)));
    }

    carregarArvoreUoUsuario() {
      this.uoService.getFilhas(this.user.uoId)
        .then(data => this.uoArvore = this.uoArvoreNivel.converterEmLista(data.plain()));
    }

    carregarUsuarios() {
      const params = {
        uoPermissao: this.uoId,
        excludePerfilIds: this.PERFIL_VDRIVERS,
        fields: this.FIELDS_USUARIO,
        includeWithoutProfiles: true
      };
      this.usuariosServiceV2.getList(params)
        .then(users => {
          this.usuarios = users.filter(usuario =>
            this.user.perfil.id === this.perfilAdminVeltec ||
            usuario.perfil === null || angular.isUndefined(usuario.perfil) || usuario.perfil.id !== this.perfilIntegracao
          );
          this.usuarios.forEach(usuario => usuario.languageLabel = this.idiomasEnum.getIdiomaByKey(usuario.idioma).value);
          this.setInfoTable(this.usuarios);
        })
        .catch(() => this.vtabela.setError());
    }

    editarUsuario(usuario) {
      return this.modalService.open({
        templateUrl: 'usuarios/editar/editar-usuario.tpl.html',
        controller: 'EditarUsuarioCtrl',
        controllerAs: 'editarUsuario',
        size: 'md',
        resolve: {
          usuario: () => usuario,
          uoArvore: () => this.uoArvore,
          isNaOu: () => this.isNaOu
        }
      }).result.then(() => this.carregarUsuarios());
    }

    allowEdit(usuarioDaLista) {
      const userWithPermissionToEdit = this.whiteList.includes(this.user.login.split('@')[1]);
      if (this.user.perfil.id === this.perfilAdminVeltec || userWithPermissionToEdit) {
        return true;
      }
      if (this.user.perfil.id === this.SUPPORT) {
        return usuarioDaLista.perfil === null || angular.isUndefined(usuarioDaLista.perfil) ||
          usuarioDaLista.perfil && usuarioDaLista.perfil.id !== this.perfilAdminVeltec;
      }
      return usuarioDaLista.perfil === null || angular.isUndefined(usuarioDaLista.perfil) ||
        usuarioDaLista.perfil.id !== this.perfilAdminVeltec && usuarioDaLista.perfil.id !== this.SUPPORT;
    }

    excluirUsuario(usuario) {
      return this.modalService.open({
        templateUrl: 'usuarios/excluir-usuario.tpl.html',
        controller: 'ExcluirUsuarioCtrl',
        controllerAs: 'excluirUsuario',
        size: 'sm',
        resolve: {
          usuario: () => usuario
        }
      }).result.then(() => this.carregarUsuarios());
    }

    cadastrarUsuario() {
      return this.modalService.open({
        templateUrl: 'usuarios/cadastrar/cadastrar-usuario.tpl.html',
        controller: 'CadastrarUsuarioCtrl',
        controllerAs: 'cadastrarUsuario',
        size: 'md',
        resolve: {
          uoSelecionada: () => this.uoId,
          uoArvore: () => this.uoArvore,
          uoArvoreNivel: () => this.uoArvoreNivel,
          isNaOu: () => this.isNaOu
        }
      }).result.then(resp => {
        this.alertMessage.create({type: 'success', message: resp, appendTo: '.alerta-aqui'});
        this.carregarUsuarios();
      });
    }
  }

  class ExcluirUsuarioCtrl {
    constructor(usuario, $uibModalInstance, Flash, UsuariosService, AlertMessage, $translate) {
      this.usuario = usuario;
      this.alertMessage = AlertMessage;
      this.modalInstance = $uibModalInstance;
      this.flash = Flash;
      this.usuariosService = UsuariosService;
      this.translate = $translate;
    }

    ok() {
      this.usuariosService.one(this.usuario.id).remove().then(
        () => {
          this.modalInstance.close();
          this.alertMessage.create({
            type: 'success',
            message: this.translate.instant('core-permissoes.organizacao.usuarios.deletion.successMessage'),
            appendTo: '.alerta-aqui'
          });
        },
        data => this.flash.create('error', data.data.message));
    }

    cancel() {
      this.modalInstance.dismiss('cancel');
    }
  }

  angular
    .module('usuarios')
    .controller('UsuariosCtrl', UsuariosCtrl)
    .controller('ExcluirUsuarioCtrl', ExcluirUsuarioCtrl);
}());
